import { CouponDto } from "services/coupons/restModels";
import { CurrencyFormatter } from "shared/lib/currencyFormatter";

/*
* Подпись скидки. Форматтер выбирается по валюте самого промокода, а не заведения: сумма
* лежит в минорных единицах, и у промокода с другой валютой число знаков после запятой
* может отличаться.
* */
export const discountLabel = (
    coupon: CouponDto,
    formatterFor: (currencyId: string | null) => CurrencyFormatter
): string =>
    coupon.type === "Percentage"
        ? `${coupon.discountPercent} %`
        : formatterFor(coupon.currencyId).toShow(coupon.discountAmount);

// 0 — промокод без ограничения по числу активаций (так его читает бэк).
export const usagesLabel = (coupon: CouponDto): string =>
    coupon.totalUsagesLimit === 0
        ? `${coupon.activationsCount} / ∞`
        : `${coupon.activationsCount} / ${coupon.totalUsagesLimit}`;
